<!-- 管理端-绩效指标详情（基于用户端页面） -->
<template>
  <div class="project_index_main month_report_main">
    <div class="project_breadcrumb_box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/adminhome/performance' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item>绩效管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 项目信息 -->
    <div class="project_header_box" style="margin-bottom:15px">
      <el-button type="text" icon="el-icon-arrow-left" @click="$router.back()">返回项目列表</el-button>
    </div>
    <div class="project_detail_box">
      <div class="project_name_box">{{ projectInfo.project_name || '加载中...' }}</div>
      <div class="project_info_box">
        <p>承接单位：{{ projectInfo.organ_name || '' }}</p>
        <p>项目周期：{{ projectInfo.approve_time_str || '' }} ~ {{ projectInfo.end_time_str || '' }}</p>
      </div>
    </div>

    <!-- 项目合同 -->
    <div class="month_report_content_box" style="margin-bottom: 20px">
      <div class="month_report_search_box"><h2>项目合同（盖章扫描件）</h2></div>
      <div style="margin-top: 20px">
        <div v-if="projectInfo.project_contract && projectInfo.project_contract.length > 0">
          <div v-for="(file, idx) in projectInfo.project_contract" :key="idx" style="margin-bottom: 10px">
            <a :href="file.href" :download="file.name" target="_blank" style="color: #3381c3; margin-right: 10px">
              <i class="el-icon-document"></i> {{ file.name || '合同文件' + (idx + 1) }}
            </a>
            <el-button type="primary" size="mini" icon="el-icon-download" @click="downloadFile(file)">下载</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteContract(idx)" style="margin-left:5px">删除</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 绩效指标（按分类） -->
    <div class="month_report_content_box" v-for="item in classList" :key="item.id" style="margin-bottom: 20px">
      <div class="month_report_search_box" style="display: flex; align-items: center">
        <h2>{{ item.name }}指标</h2>
        <el-button type="primary" size="small" icon="el-icon-plus"
          @click="openAddRuleDialog(item)" style="margin-left: 20px">添加指标</el-button>
      </div>
      <div class="month_report_table_box">
        <el-table :data="item.rules" v-if="item.rules && item.rules.length > 0">
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column label="指标名称">
            <template slot-scope="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column label="计量规则" width="80">
            <template slot-scope="scope">{{ scope.row.rule || '≥' }}</template>
          </el-table-column>
          <el-table-column label="单位" width="80">
            <template slot-scope="scope">{{ scope.row.unit || '' }}</template>
          </el-table-column>
          <el-table-column label="目标值" width="100">
            <template slot-scope="scope">{{ scope.row.number || 0 }}</template>
          </el-table-column>
          <el-table-column label="累计完成" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.is_active == 0" style="color:#ccc">-</span>
              <span v-else>{{ scope.row.completed || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="完成进度" width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.is_active == 0" style="color:#ccc">不按标准</span>
              <el-progress v-else :percentage="Math.min(parseFloat(scope.row.percent) || 0, 100)"
                :color="(parseFloat(scope.row.percent) || 0) >= 100 ? '#27ae60' : '#3381c3'"></el-progress>
            </template>
          </el-table-column>
          <el-table-column label="开关" width="70">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_active" :active-value="1" :inactive-value="0"
                @change="handleToggleActive(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="openEditRuleDialog(item, scope.row)">编辑</el-button>
              <el-button type="danger" size="small" @click="handleDeleteRule(scope.row)">删除</el-button>
              <el-button type="primary" size="small" plain @click="openHistoryDialog(scope.row)">提交记录</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-else style="text-align: center; padding: 30px; color: #999; font-size: 14px">暂无指标</div>
      </div>
    </div>

    <!-- 提交记录弹窗（同用户端） -->
    <el-dialog :title="'填报历史 — ' + (currentRule.name || '')" :visible.sync="historyShow" width="1000px">
      <div class="project_list_item_content">
        <div class="project_list_item_info">
          <div class="project_list_item_menu"><p>目标值</p><h2 style="color: #3381c3">{{ currentRule.number || 0 }}</h2></div>
          <div class="project_list_item_menu"><p>累计完成</p><h2 style="color: #3381c3">{{ currentRule.completed || 0 }}</h2></div>
          <div class="project_list_item_menu"><p>完成率</p><h2 class="yellow">{{ currentRule.percent || 0 }}%</h2></div>
          <div class="project_list_item_menu"><p>填报次数</p><h2 class="green">{{ historyList.length }}</h2></div>
        </div>
      </div>
      <div style="margin: 20px 0">
        <el-table :data="historyList" style="width:100%">
          <el-table-column label="序号" width="60">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column label="新增值" width="100">
            <template slot-scope="scope">+{{ scope.row.value || 0 }} {{ currentRule.unit || '' }}</template>
          </el-table-column>
          <el-table-column label="提交时间" width="140">
            <template slot-scope="scope">{{ scope.row.create_time ? formatTime(scope.row.create_time) : '' }}</template>
          </el-table-column>
          <el-table-column label="审核状态" width="90">
            <template slot-scope="scope">
              <el-tag :type="scope.row.approve_status==2?'success':scope.row.approve_status==3?'danger':'warning'" size="small">
                {{ scope.row.approve_status==2?'已审核':scope.row.approve_status==3?'已驳回':'审核中' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="佐证材料" min-width="120">
            <template slot-scope="scope">
              <template v-if="scope.row.files && scope.row.files.length > 0">
                <div v-for="(file, i) in scope.row.files" :key="i">
                  <a :href="file.href" target="_blank" style="color:#3381c3;margin-right:8px">
                    <i class="el-icon-document"></i> {{ file.name || '查看文件' }}
                  </a>
                  <el-button type="text" size="mini" icon="el-icon-download" @click="downloadFile(file)"></el-button>
                </div>
              </template>
              <span v-else style="color:#ccc">无</span>
            </template>
          </el-table-column>
          <el-table-column label="审核" width="150">
            <template slot-scope="scope">
              <template v-if="scope.row.approve_status == 0 && scope.row.is_save == 0">
                <el-button type="success" size="mini" @click="handleRecordApprove(scope.row, 2)">通过</el-button>
                <el-button type="danger" size="mini" @click="handleRecordApprove(scope.row, 3)">驳回</el-button>
              </template>
              <template v-else-if="scope.row.approve_status == 2 || scope.row.approve_status == 3">
                <el-button type="warning" size="mini" @click="handleRecordApprove(scope.row, 0)">撤回</el-button>
              </template>
              <span v-else style="color: #ccc">-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer"><el-button @click="historyShow = false" plain type="primary">关闭</el-button></div>
    </el-dialog>

    <!-- 审核意见弹窗 -->
    <el-dialog title="审核意见" :visible.sync="auditShow" width="500px">
      <el-input type="textarea" :rows="4" v-model="auditReason" placeholder="请输入审核意见"></el-input>
      <div slot="footer">
        <el-button @click="auditShow = false">取消</el-button>
        <el-button type="warning" @click="handleAuditSaveDraft">保存草稿</el-button>
        <el-button type="primary" @click="handleAuditConfirm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 添加/编辑指标弹窗 -->
    <el-dialog :title="ruleDialogTitle" :visible.sync="ruleDialogShow" width="550px">
      <el-form :model="ruleEditForm" label-position="top">
        <el-form-item label="指标名称" required>
          <el-input v-model="ruleEditForm.name" placeholder="请输入指标名称"></el-input>
        </el-form-item>
        <el-form-item label="计量规则">
          <el-select v-model="ruleEditForm.rule" style="width:100%">
            <el-option label="≥（大于等于）" value="≥"></el-option>
            <el-option label=">（大于）" value=">"></el-option>
            <el-option label="=（等于）" value="="></el-option>
            <el-option label="≤（小于等于）" value="≤"></el-option>
            <el-option label="<（小于）" value="<"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位">
          <el-input v-model="ruleEditForm.unit" placeholder="如：人次、次、人、篇、个"></el-input>
        </el-form-item>
        <el-form-item label="目标值" required>
          <el-input v-model.number="ruleEditForm.number" type="number" placeholder="请输入目标值"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="ruleDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveRule">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 分类弹窗 -->
    <el-dialog :title="classDialogTitle" :visible.sync="classDialogShow" width="450px">
      <el-form :model="classForm" label-position="top">
        <el-form-item label="分类名称" required>
          <el-input v-model="classForm.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="classDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveClass">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { adminGetProjectDetail, adminGetRuleList, adminGetRuleRecordList }
  from "@/api/adminModule";
import { adminSaveRule, adminDeleteRule, adminSaveRuleClass, adminApproveRuleRecord, adminDeleteContractFile }
  from "@/api/adminModule";
import { baseURL } from "@/config";
export default {
  data() {
    return {
      projectId: 0,
      projectInfo: {},
      classList: [],
      // 提交记录
      currentRule: {}, historyList: [], historyShow: false,
      // 指标弹窗
      ruleDialogShow: false, ruleDialogTitle: '',
      ruleEditForm: { id: 0, class_id: 0, name: '', rule: '≥', unit: '', number: 0 },
      // 审核意见
      auditShow: false, auditReason: '', auditRow: null, auditStatus: 0,
      // 分类弹窗
      classDialogShow: false, classDialogTitle: '',
      classForm: { id: 0, name: '' },
    };
  },
  created() {
    this.$emit("setActive", { active: 9 });
    this.projectId = this.$route.query.projectId || 0;
    if (this.projectId) { this.getProjectDetail(); this.fetchRuleList(); }
  },
  methods: {
    /**
     * 获取项目详情
     */
    async getProjectDetail() {
      const res = await adminGetProjectDetail(this.projectId);
      if (res && res.code === 200) this.projectInfo = res.data || {};
    },
    /**
     * 获取绩效指标列表
     */
    async fetchRuleList() {
      const res = await adminGetRuleList(this.projectId);
      if (res && res.code === 200) this.classList = res.data.class_list || [];
    },
    /**
     * 打开提交记录弹窗
     * @param {Object} rule
     */
    async openHistoryDialog(rule) {
      this.currentRule = rule; this.historyList = []; this.historyShow = true;
      const res = await adminGetRuleRecordList(rule.id);
      if (res && res.code === 200) this.historyList = res.data || [];
    },
    /**
     * 添加指标
     * @param {Object} classItem
     */
    openAddRuleDialog(classItem) {
      this.ruleDialogTitle = '添加指标 — ' + classItem.name;
      this.ruleEditForm = { id: 0, class_id: classItem.id, name: '', rule: '≥', unit: '', number: 0 };
      this.ruleDialogShow = true;
    },
    /**
     * 编辑指标
     * @param {Object} classItem
     * @param {Object} row
     */
    openEditRuleDialog(classItem, row) {
      this.ruleDialogTitle = '编辑指标 — ' + classItem.name;
      this.ruleEditForm = {
        id: row.id, class_id: classItem.id,
        name: row.name, rule: row.rule || '≥', unit: row.unit || '', number: row.number || 0,
      };
      this.ruleDialogShow = true;
    },
    /**
     * 保存指标
     */
    async handleSaveRule() {
      if (!this.ruleEditForm.name) { this.$message.warning('请输入指标名称'); return; }
      if (!this.ruleEditForm.number || this.ruleEditForm.number <= 0) { this.$message.warning('请输入有效目标值'); return; }
      const res = await adminSaveRule({
        id: this.ruleEditForm.id, project_id: this.projectId, class_id: this.ruleEditForm.class_id,
        name: this.ruleEditForm.name, rule: this.ruleEditForm.rule, unit: this.ruleEditForm.unit,
        number: this.ruleEditForm.number,
      });
      if (res && res.code === 200) { this.$message.success('保存成功'); this.ruleDialogShow = false; this.fetchRuleList(); }
      else { this.$message.error((res && res.message) || '保存失败'); }
    },
    /**
     * 切换指标开关
     * @param {Object} row
     */
    async handleToggleActive(row) {
      const res = await adminSaveRule({
        id: row.id, project_id: this.projectId, class_id: row.class_id || 0,
        name: row.name, rule: row.rule, unit: row.unit, number: row.number, is_active: row.is_active,
      });
      if (!res || res.code !== 200) { this.$message.error('切换失败'); this.fetchRuleList(); }
    },
    /**
     * 删除指标
     * @param {Object} row
     */
    async handleDeleteRule(row) {
      this.$confirm('确认删除指标「' + row.name + '」？', '提示', { type: 'warning' }).then(async () => {
        const res = await adminDeleteRule(row.id);
        if (res && res.code === 200) { this.$message.success('删除成功'); this.fetchRuleList(); }
        else { this.$message.error((res && res.message) || '删除失败'); }
      }).catch(() => {});
    },
    /**
     * 审核填报记录（通过/驳回/撤回）
     * @param {Object} row 记录
     * @param {Number} status 2=通过 3=驳回 0=撤回
     */
    async handleRecordApprove(row, status) {
      if (status == 3) {
        // 驳回：打开审核意见弹窗
        this.auditRow = row; this.auditStatus = 3; this.auditReason = row.refund_reason || ''; this.auditShow = true;
        return;
      }
      const actionText = status == 2 ? '通过' : '撤回';
      this.$confirm(`确认${actionText}该记录？`, '提示', { type: 'warning' }).then(async () => {
        const res = await adminApproveRuleRecord({ id: row.id, approve_status: status });
        if (res && res.code === 200) { this.$message.success(actionText + '成功'); this.openHistoryDialog(this.currentRule); }
        else { this.$message.error((res && res.message) || '操作失败'); }
      }).catch(() => {});
    },
    /** 审核意见-保存草稿（仅保存意见不提交） */
    handleAuditSaveDraft() { this.$message.info('审核意见已暂存'); },
    /** 审核意见-确定驳回 */
    async handleAuditConfirm() {
      const res = await adminApproveRuleRecord({ id: this.auditRow.id, approve_status: this.auditStatus, refund_reason: this.auditReason });
      if (res && res.code === 200) { this.$message.success('已驳回'); this.auditShow = false; this.openHistoryDialog(this.currentRule); }
      else { this.$message.error((res && res.message) || '操作失败'); }
    },

    /**
     * 下载文件（处理跨域文件名问题）
     * @param {Object} file {name, href}
     */
    async deleteContract(idx) {
      this.$confirm('确认删除该合同文件？', '提示', { type: 'warning' }).then(async () => {
        const res = await adminDeleteContractFile(this.projectId, idx);
        if (res && res.code === 200) { this.$message.success('删除成功'); this.getProjectDetail(); }
        else { this.$message.error((res && res.message) || '删除失败'); }
      }).catch(() => {});
    },
    downloadFile(file) {
      const url = baseURL + '/download?url=' + encodeURIComponent(file.href) + '&name=' + encodeURIComponent(file.name || '文件');
      window.open(url, '_blank');
    },

    /**
     * 添加分类
     */
    openClassDialog() {
      this.classDialogTitle = '添加分类'; this.classForm = { id: 0, name: '' }; this.classDialogShow = true;
    },
    /**
     * 保存分类
     */
    async handleSaveClass() {
      if (!this.classForm.name) { this.$message.warning('请输入分类名称'); return; }
      const res = await adminSaveRuleClass({ id: this.classForm.id, name: this.classForm.name });
      if (res && res.code === 200) { this.$message.success('保存成功'); this.classDialogShow = false; this.fetchRuleList(); }
      else { this.$message.error((res && res.message) || '保存失败'); }
    },
    /**
     * 格式化时间戳
     * @param {Number} ts
     */
    formatTime(ts) {
      if (!ts) return '';
      const d = new Date(ts * 1000), pad = n => String(n).padStart(2, '0');
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate())
        + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    },
  },
};
</script>

<style scoped lang="scss">
@import url("index.scss");
@import url("performance.scss");
</style>
